import React from 'react';
import { getStorage } from './services/common/storage';
import { ContextModel } from './services/models/Context';


function getUserContext()
{
  return getStorage();
}

const defaultPreferenceState = {
  userContext: getUserContext(),
  updateUserContext: (context: ContextModel) =>  {},
};

export const PreferencesContext = React.createContext(defaultPreferenceState);

